import React from 'react'
import {Switch, Route, Router} from 'react-router-dom';
import { useHistory } from '../../hooks/use-history';

const SpecialOffersTier1 = () => {
  const history = useHistory();
  return (
    <>
    <Router history={history}>
      <Switch>
        <Route exact path="/">
        <div>Special Offers Tier 1</div>
        </Route>
      </Switch>
      </Router>
    </>
  )
}

export default SpecialOffersTier1